export default {
  oportunidades: [],
  oportunidades_list: [],
  oportunidade: {
    ods: [],
  },
  oportunidade_estatisticas: {},
  loading: false,
  modelo_contrapartidas: [],
  pagination: {
    current_page: 1,
    per_page: 15,
  },
  ods: [],
};
